export const SocketCommand = {

  Pusher: {
    Pong    : 'pusher:pong',
    IsOnline: 'pusher:is-online'
  },

  GetClientId      : 'client-id',
  HasElectronActive: 'has-electron-active',

  // AJAX
  Ajax: {
    Get: 'get-ajax'
  },

  // Electron
  ElectronApp: {
    HardReload         : 'electron-app-hard-reload',
    Reload             : 'electron-app-reload',
    ClearHttpCache     : 'electron-app-clear-http-cache',
    ClearStorageCache  : 'electron-app-clear-storage-cache',
    ClearAllCache      : 'electron-app-clear-all-cache',
    RetryLoadMainApp   : 'electron-app-retry-loading-main-app',
    ClearAllAndRelaunch: 'electron-app-clear-all-and-relaunch',
    Relaunch           : 'electron-app-relaunch'
  },

  // ACTIVITY LOG
  ActivityLog: {
    All       : 'get-activity-log-list',
    AllFilters: 'get-activity-log-filters'
  },

  // DASHBOARD
  Dashboard: {
    Get: 'get-dashboard'
  },

  // GALLERY
  Gallery: {
    All   : 'get-gallery',
    Delete: 'delete-gallery-image'
  },

  // VOIP
  Voip: {
    Incoming: 'get-voip-incoming',
    Answer  : 'get-voip-answer',
    Hangup  : 'get-voip-hangup',
    History : 'get-voip-history'
  },

  // FAQS
  Faq: {
    All   : 'get-faq-list',
    Manage: {
      All   : 'get-faqs-list',
      Save  : 'save-faq',
      Delete: 'delete-faq'
    },
    Category: {
      All   : 'get-faq-categories',
      Combo : 'get-faq-categories-combo',
      Save  : 'save-faq-category',
      Delete: 'delete-faq-category'
    }
  },

  // GOOGLE TRANSLATION
  Translate: {
    Get: 'get-translate'
  },

  // ACCOUNT
  Account: {
    Get        : 'get-account',
    Save       : 'save-account',
    UpdateTheme: 'update-account-theme',
    Delete     : 'delete-account',
    Billing    : {
      Get : 'get-account-billing',
      Save: 'save-account-billing'
    },
    Plans: {
      List: 'get-account-plans'
    },
    Invoices: {
      List: 'get-account-invoices'
    },
    DomainExtendPeriod: 'domain-extend-period'
  },

  // SETTINGS
  Settings: {
    Permissions: {
      All   : 'get-permissions',
      Save  : 'save-permission',
      Delete: 'delete-permission'
    },
    Printer: {
      Group: {
        All   : 'get-printer-groups',
        Save  : 'save-printer-group',
        Delete: 'delete-printer-group'
      }
    },
    Machine: {
      Group: {
        All   : 'get-machine-groups',
        Save  : 'save-machine-group',
        Delete: 'delete-machine-group'
      }
    },
    Restaurant: {
      Get : 'get-restaurant-settings',
      Save: 'save-restaurant-settings'
    },
    Delivery: {
      Get : 'get-delivery-settings',
      Save: 'save-delivery-settings'
    },
    Orders: {
      Get : 'get-orders-settings',
      Save: 'save-orders-settings'
    },
    Documents: {
      Get : 'get-documents-settings',
      Save: 'save-documents-settings'
    },
    Tables: {
      Get : 'get-tables-settings',
      Save: 'save-tables-settings'
    },
    PinManager: {
      Get : 'get-pin-manager-settings',
      Save: 'save-pin-manager-settings'
    },
    Reservations: {
      Get : 'get-table-reservation-settings',
      Save: 'save-table-reservation-settings'
    },
    Website: {
      Get     : 'get-website-settings',
      Save    : 'save-website-settings',
      GetPage : 'get-website-page-settings',
      SavePage: 'save-website-page-settings'
    },
    Regional: {
      Get : 'get-regional-settings',
      Save: 'save-regional-settings'
    },
    Notifications: {
      Get : 'get-notifications-settings',
      Save: 'save-notifications-settings'
    },
    Email: {
      Get : 'get-email-settings',
      Save: 'save-email-settings',
      Test: 'test-email-settings'
    },
    Payments: {
      Get   : 'get-payments-settings',
      Save  : 'save-payment-settings',
      Vendor: {
        Save: 'save-pos-vendor-settings',
        Env : 'save-pos-vendor-env'
      },
      Terminal: {
        Add: {
          Viva  : 'add-payment-terminal-viva',
          WebEcr: 'add-payment-terminal-webecr'
        },
        Get   : 'get-payment-terminal-settings',
        Save  : 'save-payment-terminal-settings',
        Delete: 'delete-payment-terminal-settings'
      }
    },
    Catalog: {
      Copy: 'catalog-copy-data'
    },
    Domains: {
      All        : 'get-domains',
      Save       : 'save-domain',
      CheckDomain: 'check-domain',
      CheckCName : 'check-cname',
      Backup     : 'backup-domain',
      Import     : 'parse-menu',
      Copy       : 'domain-copy-data',
      MoveDB     : 'domain-db-move',
      BackupDB   : 'domain-db-backup',
      Delete     : 'domain-delete',
      Settings   : 'domain-settings',
      ComboList  : 'get-domains-combo',
      Customer   : {
        Save     : 'save-domain-customer',
        Get      : 'get-domain-customer-data',
        SendEmail: 'send-domain-customer-mail'
      },
      PaymentFee             : 'domain-payment-fee',
      CacheClear             : 'cache-clear-domain',
      CacheClearUpdateVersion: 'cache-clear-update-version',
      RunSchedules           : 'run-schedules',
      Export                 : 'export-domains'
    },
    VoipDomains: {
      All   : 'get-voip-domains',
      Save  : 'save-voip-domain',
      Delete: 'delete-voip-domain',
      User  : {
        Save  : 'save-voip-domain-user',
        Delete: 'delete-voip-domain-user'
      }
    },
    SystemUsers: 'get-all-users',
    Misc       : {
      Countries: 'get-countries-combo'
    }
  },

  // SYSTEM
  System: {
    Init  : 'app-init',
    Ping  : 'app-ping',
    Config: 'app-config',
    Socket: {
      Clients           : 'get-socket-clients',
      ChannelConnections: {
        Ws : 'ws-channel-connections',
        Get: 'get-socket-connections'
      }
    },
    LogoutUsers : 'logout-users',
    ReloginUsers: 'relogin-users',
    Printers    : {
      Get : 'get-printers',
      Save: 'save-printers',
      Set : 'store-printers'
    },
    Kds: {
      Get : 'get-kds',
      Save: 'save-kds'
    },
    Machines: {
      UpdatePrinterMachine: 'update-printer-machine',
      UpdateDisplayMachine: 'update-display-machine',
      DeletePrinterMachine: 'delete-printer-machine',
      DeleteDisplayMachine: 'delete-display-machine'
    },
    Displays: {
      Get : 'get-displays',
      Save: 'save-displays',
      Set : 'store-displays'
    }
  },

  // Support Center
  SupportCenter: {
    Ticket: {
      All       : 'get-ticket-list',
      Lists     : 'get-ticket-lists',
      Get       : 'get-ticket-get',
      ReadUpdate: 'get-ticket-read',
      Add       : 'get-ticket-add',
      AddReply  : 'get-ticket-reply',
      GetReplies: 'get-ticket-replies'
    },
    PushReply: {
      AfterReplyAdded: 'after-ticket-reply-added-s2s',
      AfterUpdated   : 'after-ticket-updated-s2s'
    }
  },

  // MESSAGES
  Message: {
    All            : 'get-messages-list',
    Counts         : 'get-messages-counts',
    MarkRead       : 'set-message-read',
    Config         : 'get-messages-config',
    Send           : 'message-send',
    SendWithEmail  : 'message-send-with-email',
    SendWithMessage: 'message-send-internal',
    Delete         : 'message-delete',
    Templates      : 'message-templates',
    GetTemplate    : 'get-message-template',
    SaveTemplate   : 'save-message-template',
    DeleteTemplate : 'delete-message-template'
  },

  // CUSTOMER
  Customer: {
    All             : 'get-customers',
    Get             : 'get-customer',
    GetDetails      : 'get-customer-details',
    Companies       : 'get-customer-companies',
    CompaniesAll    : 'get-all-companies',
    ReplyForNewOrder: 'get-customer-for-new-order',
    Save            : 'save-customer',
    Delete          : 'delete-customer',
    Voip            : 'get-voip-customers',
    Export          : 'export-customers',
    Import          : 'import-customers',
    AddressValidate : 'customer-address-validate'
  },

  // CUSTOMER GROUPS
  CustomerGroup: {
    All : 'get-customer-groups',
    Save: 'save-customer-group'
  },

  // CATEGORY
  Category: {
    All         : 'get-categories',
    AllFilter   : 'get-categories-filter',
    Get         : 'get-category',
    Save        : 'save-category',
    Duplicate   : 'duplicate-category',
    Delete      : 'delete-category',
    UpdateStatus: 'update-category-status',
    Import      : 'import-categories',
    Export      : 'export-categories'
  },

  // CATALOG
  Catalog: {
    All          : 'get-catalogs',
    Save         : 'save-catalog',
    Delete       : 'delete-catalog',
    Duplicate    : 'duplicate-catalog',
    ImportWolt   : 'wolt-catalog',
    ImportEFood  : 'efood-catalog',
    ImportFoody  : 'foody-catalog',
    ImportFagi   : 'fagi-catalog',
    ImportBox    : 'box-catalog',
    ImportGetFood: 'getfood-catalog',
    TaxesOrphaned: 'taxes-orphaned'
  },

  // TAGS
  Tag: {
    All   : 'get-tags',
    Save  : 'save-tag',
    Delete: 'delete-tag'
  },

  // MARKETING
  Marketing: {
    Coupon: {
      All    : 'get-coupons',
      Save   : 'save-coupon',
      History: 'get-coupon-history'
    },

    Tag: {
      Combo : 'get-marketing-tag-combo',
      All   : 'get-marketing-tag-list',
      Get   : 'get-marketing-tag',
      Save  : 'save-marketing-tag',
      Delete: 'delete-marketing-tag'
    },

    Email: {
      All         : 'get-marketing-email-list',
      Get         : 'get-marketing-email',
      GetDuplicate: 'get-marketing-email-duplicate',
      Save        : 'save-marketing-email',
      Delete      : 'delete-marketing-email',
      Send        : 'send-marketing-email',
      Template    : {
        All   : 'get-marketing-email-template-list',
        Get   : 'get-marketing-email-template',
        Save  : 'save-marketing-email-template',
        Delete: 'delete-marketing-email-template'
      }
    },

    Sms: {
      All         : 'get-marketing-sms-list',
      Get         : 'get-marketing-sms',
      GetDuplicate: 'get-marketing-sms-duplicate',
      Save        : 'save-marketing-sms',
      Delete      : 'delete-marketing-sms',
      Send        : 'send-marketing-sms',
      Template    : {
        All   : 'get-marketing-sms-template-list',
        Get   : 'get-marketing-sms-template',
        Save  : 'save-marketing-sms-template',
        Delete: 'delete-marketing-sms-template'
      }
    },

    Push: {
      All         : 'get-marketing-push-list',
      Get         : 'get-marketing-push',
      GetDuplicate: 'get-marketing-push-duplicate',
      Save        : 'save-marketing-push',
      Delete      : 'delete-marketing-push',
      Send        : 'send-marketing-push',
      Template    : {
        All   : 'get-marketing-push-template-list',
        Get   : 'get-marketing-push-template',
        Save  : 'save-marketing-push-template',
        Delete: 'delete-marketing-push-template'
      }
    },

    Print: {
      All      : 'get-marketing-print-template-list',
      Get      : 'get-marketing-print-template',
      Duplicate: 'duplicate-marketing-print-template',
      Save     : 'save-marketing-print-template',
      Delete   : 'delete-marketing-print-template'
    }
  },

  // ORDERS
  Order: {
    Counts            : 'get-orders-counts',
    DailyList         : 'get-daily-orders',
    DailyGet          : 'get-daily-order',
    ScheduledList     : 'get-future-orders',
    SavedList         : 'get-saved-orders',
    AllList           : 'get-all-orders',
    GetDetails        : 'get-order-details',
    Delivery          : 'get-daily-orders-delivery',
    Lost              : 'get-daily-lost',
    UpdateStatus      : 'update-order-status',
    StatusUpdated     : 'order-status-updated',
    RetryExternal     : 'order-external-retry',
    UpdateTime        : 'update-order-time',
    Cancel            : 'order-cancel',
    RevertStatus      : 'update-order-status-to-completed',
    Delete            : 'order-delete',
    Print             : 'send-order-for-print',
    MenuPrintMarketing: 'send-menu-marketing-for-print',
    PrintPreparation  : 'send-order-preparation-for-print',
    Edit              : 'order-edit',
    RunClearanceJob   : 'receipts-clearance-job',
    PrintNotify       : 'order-print-notify',
    DeliveryNotify    : 'order-delivery-notify',
    StatusNotify      : 'order-status-notify',
    Webhook           : {
      Get    : 'get-webhook-orders',
      Retry  : 'order-webhook-retry',
      History: 'get-order-webhook-history'
    },
    Payment: {
      Pay        : 'pay-order',
      Transaction: {
        ConvertDeliveryCardToCash: 'order-payment-transaction-convert-to-cash',
        ChangePaymentType        : 'order-payment-transaction-change',
        ManualAccept             : 'order-payment-transaction-user-confirmed',
        Add                      : 'order-payment-transaction-add',
        Remove                   : 'order-payment-transaction-remove',
        Update                   : 'order-payment-transaction-update',
        OrderResult              : 'order-payment-transaction-result',
        CartResult               : 'cart-payment-transaction-result',
        Sale                     : 'order-payment-transaction-sale',
        Refund                   : 'order-payment-transaction-refund'
      }
    },
    Report: {
      EmailOrdersReport  : 'orders-report-to-email',
      EmailReceiptsReport: 'receipts-report-to-email'
    }
  },

  // PAYMENTS
  Payment: {
    EftPos: {
      All         : 'get-eft-pos-transaction-list',
      Get         : 'get-eft-pos-transaction',
      Result      : 'get-eft-pos-transaction-result',
      Retry       : 'get-eft-pos-transaction-retry',
      Refund      : 'get-eft-pos-transaction-refund',
      Refresh     : 'get-eft-pos-transaction-refresh',
      ResendAll   : 'get-eft-pos-transaction-resend-all',
      Filters     : 'get-eft-pos-transaction-filters',
      Export      : 'get-eft-pos-transaction-list-export',
      ManualAccept: 'get-eft-pos-transaction-user-confirmed'
    }
  },

  // RECEIPTS
  Receipt: {
    All                                  : 'get-receipt-list',
    Get                                  : 'get-receipt',
    Retry                                : 'receipt-retry',
    Filters                              : 'get-receipt-filters',
    Print                                : 'send-receipt-for-print',
    PrintManual                          : 'send-receipt-for-print-manual',
    Cancel                               : 'receipt-cancel',
    Update                               : 'fiscal-document-update',
    PaymentUpdate                        : 'order-receipt-payments-update',
    Generate                             : 'receipt-generate',
    GenerateFromCartTablePaymentTimestamp: 'cart-table-receipt-from-timestamp',
    Notify                               : 'receipt-notify',
    NotifyPrint                          : 'receipt-notify-print',
    NotifyEmail                          : 'receipt-notify-email',
    MyDataStatus                         : 'get-mydata-status',
    CompanyPackage                       : 'get-receipts-company-package',
    DocumentsStatus                      : 'get-documents-status',
    Export                               : 'receipts-list-export',
    ConvertToInvoice                     : 'convert-receipt-to-invoice',
    FiscalDocNotIssued                   : 'fiscal-document-not-issued'
  },

  // MENU
  Menu: {
    All            : 'get-menu',
    Select         : 'get-menu-select',
    Pos            : 'get-menus-pos',
    PosUpdate      : 'get-menus-pos-update',
    PosItem        : 'get-menus-pos-item',
    Get            : 'get-menu-item',
    Save           : 'save-menu-item',
    Duplicate      : 'duplicate-menu-item',
    MergeOptions   : 'duplicate-menu-options',
    Delete         : 'delete-menu-item',
    GetAdmin       : 'get-admin-menu-item',
    UpdateStatus   : 'update-menu-item-status',
    UpdateValue    : 'update-menu-item-value',
    GetHistoryAdmin: 'get-admin-menu-item-history',
    Import         : 'import-menu',
    Export         : 'export-menu',

    // MENU OPTIONS
    Options: {
      All      : 'get-menus-options',
      AllFilter: 'get-menus-options-filter',
      Save     : 'save-menus-option',
      Delete   : 'delete-menus-option',
      Duplicate: 'duplicate-menus-option'
    },

    // MENU OPTION VALUE GROUPS
    OptionValueGroup: {
      All   : 'get-menu-option-value-groups',
      Save  : 'save-menu-option-value-group',
      Delete: 'delete-menu-option-value-group'
    }
  },

  // STAFF
  Staff: {
    All             : 'get-staffs',
    Save            : 'save-staff',
    ChangeUserSingle: 'change-user-single',
    ChangeDomain    : 'change-staff-domain',

    // STAFF GROUPS
    Group: {
      All : 'get-staff-groups',
      Save: 'save-staff-group'
    },

    Delivery: {
      // DELIVERY STAFF
      All          : 'get-delivery-staff-list',
      ShiftsHistory: 'get-delivery-staff-list-by-id',
      Save         : 'save-delivery-staff',
      Delete       : 'delete-delivery-staff',
      Shift        : {
        Open       : 'open-delivery-staff-shift',
        Close      : 'close-delivery-staff-shift',
        AddOrder   : 'add-delivery-staff-shift-order',
        RemoveOrder: 'remove-delivery-staff-shift-order'
      },
      SaveGeo: 'save-delivery-staff-geo',
      // DELIVERY USERS
      User   : {
        Dashboard  : 'get-delivery-user-dashboard',
        Shift      : 'get-delivery-user-shift',
        ShiftUpdate: 'get-delivery-user-shift-update',
        EftPos     : {
          Sale     : 'add-delivery-user-eft-pos-sale',
          Refund   : 'add-delivery-user-eft-pos-refund',
          Terminals: 'get-delivery-user-eft-pos-terminals'
        },
        Receipt: {
          Generate: 'receipt-generate-from-delivery-staff',
          Print   : 'receipt-print-from-delivery-staff'
        },
        ShiftOpen     : 'open-delivery-user-shift',
        ShiftClose    : 'close-delivery-user-shift',
        AddOrder      : 'add-delivery-user-shift-order',
        RemoveOrder   : 'remove-delivery-user-shift-order',
        SetOrderStatus: 'update-delivery-user-shift-order-status'
      }
    },

    // WAITER STAFF
    Waiter: {
      All          : 'get-waiter-staff-list',
      ShiftsHistory: 'get-waiter-staff-list-by-id',
      Save         : 'save-waiter-staff',
      Delete       : 'delete-waiter-staff',
      Payment      : {
        ChangeWaiter: 'move-waiter-staff-shift-payments'
      },
      Shift: {
        Open   : 'open-waiter-staff-shift',
        Close  : 'close-waiter-staff-shift',
        Changed: 'get-waiter-staff-shift-changed'
      }
    }
  },

  // Cart
  Cart: {
    Init              : 'cart-init',
    InitFromEftPayment: 'cart-init-from-eft-payment',
    Update            : 'cart-update',
    Destroy           : 'cart-destroy',
    TableItems        : {
      Add: 'cart-add-items'
    },
    Item: {
      Add   : 'cart-add-item',
      Update: 'cart-update-item',
      Remove: 'cart-remove-item'
    },
    Coupon: {
      Add   : 'cart-add-coupon',
      Remove: 'cart-remove-coupon'
    },
    Tip: {
      Add   : 'cart-add-tip',
      Remove: 'cart-remove-tip'
    },
    Scheduled: {
      Update: 'cart-scheduled-update'
    },
    ExtraCharge: {
      Add   : 'cart-add-extra-charge',
      Remove: 'cart-remove-extra-charge',
      Delete: 'cart-delete-extra-charge'
    },
    Order: {
      Complete: 'cart-order-complete'
    }
  },

  // LOCATION
  Location: {
    OnlineOrderingStatus: 'get-online-ordering-status'
  },

  // WORKING HOURS
  WorkingHours: {
    All : 'get-working-hours',
    Save: 'save-working-hours'
  },

  // MEAL TIMES
  MealTimes: {
    All      : 'get-mealtimes',
    AllFilter: 'get-mealtimes-filter',
    Save     : 'save-mealtime'
  },

  // KDS
  Kds: {
    All  : 'get-kds-list',
    Order: {
      Get             : 'get-kds-order',
      ChangeStatus    : 'kds-change-order-status',
      ChangeItemStatus: 'kds-change-order-item-status',
      ChangePriority  : 'kds-change-order-priority'
    }
  },

  // QR CODES
  QRCode: {
    All     : 'get-qr-list',
    Save    : 'save-qr',
    Delete  : 'delete-qr',
    Export  : 'export-qr',
    Settings: {
      Save: 'save-qr-options'
    }
  },

  // Extra Charges
  ExtraCharge: {
    All   : 'get-charges',
    Save  : 'save-charge',
    Delete: 'delete-charge'
  },

  // TABLES
  Table: {
    All                       : 'get-table-list',
    AllByArea                 : 'get-tables',
    Get                       : 'get-table',
    GetById                   : 'get-table-by-id',
    Save                      : 'save-table',
    Delete                    : 'delete-table',
    Merge                     : 'merge-table',
    Show                      : 'show-table',
    ShowOffline               : 'show-table-offline',
    MoveOrderItems            : 'move-table',
    Open                      : 'open-table',
    Close                     : 'close-table',
    Pay                       : 'pay-table',
    ChangeWaiter              : 'change-table-waiter-staff',
    ChangePersons             : 'change-table-persons',
    SetAwaitingPaymentStatus  : 'set-awaiting-payment-table-status',
    UnsetAwaitingPaymentStatus: 'unset-awaiting-payment-table-status',
    Cancel                    : {
      Items: 'cancel-table-items'
    },
    PrintOrderTable             : 'print-order-table',
    SendOrderForPrint           : 'send-order-table-for-print',
    SendOrderPreparationForPrint: 'send-order-table-preparation-for-print',
    SendOrderMarketingForPrint  : 'send-order-table-marketing-for-print',
    SendCanceledForPrint        : 'send-order-table-items-canceled-for-print',
    SendReceiptForPrint         : 'send-receipt-table-for-print',
    ToggleOrderExternalReceipt  : 'table-cart-external-receipt',
    IssueOrderReceiptDocument   : 'table-cart-provider-receipt',
    Cart                        : {
      Complete          : 'cart-table-complete',
      UpdateUnitItem    : 'cart-table-update-unit-item',
      RevertPaymentItems: 'cart-table-revert-payment-items',
      ItemsForPayment   : 'cart-table-items-for-payment'
    },
    Area: {
      All   : 'get-table-area-list',
      List  : 'get-table-area-combo',
      Save  : 'save-table-area',
      Delete: 'delete-table-area'
    },
    Coupon: {
      Add   : 'table-add-coupon',
      Remove: 'table-remove-coupon'
    },
    Reservation: {
      All     : 'get-table-reservation-list',
      Save    : 'save-table-reservation',
      Cancel  : 'cancel-table-reservation',
      Status  : 'status-table-reservation',
      Delete  : 'delete-table-reservation',
      Validate: 'validate-table-reservation'
    },
    Transaction: {
      AddMultiple : 'cart-table-payment-transactions-add',
      ManualAccept: 'cart-table-payment-transaction-user-confirmed',
      Add         : 'cart-table-payment-transaction-add',
      Remove      : 'cart-table-payment-transaction-remove',
      Update      : 'cart-table-payment-transaction-update',
      Result      : 'cart-table-payment-transaction-result',
      Sale        : 'cart-table-payment-transaction-sale',
      Refund      : 'cart-table-payment-transaction-refund'
    }
  },

  // STATISTICS
  Statistics: {
    Products: {
      All   : 'get-statistics-products',
      Export: 'export-statistics-products'
    },
    OrdersHeatmap: {
      All: 'get-statistics-orders-heatmap'
    }
  },

  Reports: {
    SalesReportZ: {
      All   : 'get-statistics-sales-report-z',
      Export: 'export-statistics-sales-report-z'
    },
    ReportsNotify: {
      All    : 'get-reports-notify-list',
      Filters: 'get-reports-notify-filters'
    },
    Delete: 'delete-reports-notify-item'
  },

  /**
   *
   * @param command {String}
   * @returns {String}
   */
  commandToSocketFormat: (command) => {
    return command?.toUpperCase()?.replace(new RegExp('-', 'g'), '_')
  },

  /**
   *
   * @param command {String}
   * @returns {String}
   */
  commandToClientFormat: (command) => {
    return command?.toLowerCase()?.replace(new RegExp('_', 'g'), '-')
  }
}

export default SocketCommand
